import { useEffect, useRef, useState } from "react";
import PerformanceStore from "../../store/PerformanceStore";

function SortTable(arrData, key, isSortedAtoZ, pushObj) {
  const [keyForOrdering, setKeyForOrdering] = useState(key);
  const [isAscending, setIsAscending] = useState(isSortedAtoZ);
  const [sortedArr, setSortedArr] = useState([]);
  const sortRef = useRef();

  const sortingFuction = (localKey = keyForOrdering, localCondition) => {
    if (arrData?.length) {
      for (let i = arrData?.length; i > 0; i--) {
        for (let j = 0; j < i; j++) {
          let valueToCheck = "";
          let nextValueToCheck = "";
          if (localKey?.key2 === undefined) {
            valueToCheck = arrData?.[j]?.[localKey.key1];
            nextValueToCheck = arrData?.[j + 1]?.[localKey.key1];
          } else if (localKey?.key3 === undefined) {
            valueToCheck = arrData?.[j]?.[localKey.key1]?.[localKey.key2];
            nextValueToCheck =
              arrData?.[j + 1]?.[localKey.key1]?.[localKey.key2];
          } else {
            valueToCheck =
              arrData?.[j]?.[localKey.key1]?.[localKey.key2]?.[localKey.key3];
            nextValueToCheck =
              arrData?.[j + 1]?.[localKey.key1]?.[localKey.key2]?.[
                localKey.key3
              ];
          }
          let tempValueToCheck = valueToCheck;

          if (
            isNaN(Number(tempValueToCheck?.replaceAll("-", ""))) &&
            isNaN(tempValueToCheck?.replaceAll(",", ""))
          ) {
            for (let k = 0; k < valueToCheck?.length; k++) {
              let a = valueToCheck?.charCodeAt(k);
              let b = nextValueToCheck?.charCodeAt(k);
              let temp = null;

              if (a > b && a - b !== 32) {
                temp = arrData?.[j];
                arrData[j] = arrData?.[j + 1];
                arrData[j + 1] = temp;
                break;
              } else if (a < b && a - b !== 32) {
                break;
              }
            }
          } else if (
            valueToCheck?.includes(".") ||
            valueToCheck?.includes(",") ||
            !isNaN(valueToCheck) ||
            (valueToCheck?.includes("-") && valueToCheck?.indexOf("-") === 0)
          ) {
            let temp = null;
            let firstValue = valueToCheck?.replaceAll(",", "");
            let secondValue = nextValueToCheck?.replaceAll(",", "");
            if (Number(firstValue) > Number(secondValue)) {
              temp = arrData?.[j];
              arrData[j] = arrData?.[j + 1];
              arrData[j + 1] = temp;
            }
          } else {
            let temp = null;
            if (
              Number(valueToCheck?.replaceAll("-", "")) >
              Number(nextValueToCheck?.replaceAll("-", ""))
            ) {
              temp = arrData?.[j];
              arrData[j] = arrData?.[j + 1];
              arrData[j + 1] = temp;
            }
          }
        }
      }
    }
    setSortedArr(arrData);
    PerformanceStore.setIsDataSorted(true);
  };

  sortRef.current = sortingFuction;

  const handleOrdering = (key, condition) => {
    setKeyForOrdering(key);
    condition !== undefined
      ? setIsAscending(condition)
      : setIsAscending((prevState) => !prevState);

    sortingFuction(key, condition);
  };

  useEffect(() => {
    //  sortingFuction(keyForOrdering, isAscending);
    sortRef.current();
  }, []);

  return {
    isAscending: isAscending,
    key1:
      keyForOrdering.key2 !== undefined && keyForOrdering.key2 === "xirr"
        ? "xirr"
        : keyForOrdering.key2 !== undefined && keyForOrdering.key2 === "subtext"
        ? "subtext"
        : keyForOrdering.key1,
    arrData: isAscending
      ? sortedArr
      : arrData
      ? sortedArr?.slice()?.reverse()
      : [],
    setKeyForOrdering: (key, condition) => handleOrdering(key, condition),
  };
}

export default SortTable;
